import axios from '@/axios';

export default {
  methods: {
    downloadConfirm(params) {
      const { documentGuid } = params;
      if (documentGuid.length === 0) {
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadNoItemsSelectedMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });

        return;
      }
      this.$vs.dialog({
        type: 'confirm',
        title: this.$t('ConfirmDownload'),
        text: this.$t('ConfirmDownloadMessage'),
        accept: () => this.multiDownload(params),
        acceptText: this.$t('Download'),
      });
    },
    async download(params) {
      console.log("Do download with following params: ", params);
      //return;

      try {
        //const file = await this.getDownloadInfo(params)
        const file = await this.getFile(params)

        //this.getFile(file)

      } catch (e) {
        console.log(e);
      }
    },
    async getFile(file) {
      try {
        const { data } = await this.$api[this.apiModel].downloadDocument(this.model.id, file.Document_UID)

        const blob = new Blob([data], { type: this.getFileType(file.FileExtension) })
        const filename = file.FriendlyName + '.' + file.FileExtension;

        const link = document.createElement('a')

        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.click()

        URL.revokeObjectURL(link.href)
      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async getDownloadInfo(params) {
      const documentGuids = this.formatGuidsForApi(params.documentGuid);

      try {
        const { data } = await this.$api[params.documentType].list({params: documentGuids});
        return data.data;

      } catch (e) {
        console.log(e);
        this.$vs.notify({
          title: this.$t('ErrorOccurred'),
          text: this.$t('DownloadFileFailureMessage'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        });
      }
    },
    async multiDownload(params) {
      console.log("Get download link params: ", params);

      try {
        const file = await this.getDownloadInfo(params)

        if (file.EmailReturn) {
          this.$vs.dialog({
            type: 'alert',
            title: this.$t('Download'),
            text: this.$t('DownloadEmailSuccessMessage'),
            acceptText: this.$t('Close'),
          });
        } else {
          this.$vs.dialog({
            type: 'alert',
            title: this.$t('Download'),
            text: this.$t('DownloadSuccessMessage'),
            accept: () => this.getFile(file),
            acceptText: this.$t('Download'),
          });
        }


      } catch (e) {
        console.log(e);
      }
    },
    formatGuidsForApi(guids) {

      let data = {};
      for (const key in guids) {
        data['documentGuid[' + key + ']'] = guids[key];
      }

      return data;
    },
    getFileType(extension) {
      let fileType;
      switch (extension) {

        default:
          fileType = 'application/' + extension;
          break;
      }

      return fileType;
    }
  },
};
